import {
  THEME_CATEGORIES,
  type ThemeCategory,
  type ThemePlugin,
} from '#/types/capsule'
import classicQuiz from './classic-quiz'
import htmlBridge from './html-bridge'
import liquidGlass from './liquid-glass'
import pixelArt from './pixel-art'
import summer from './summer'

export {THEME_CATEGORIES}

export const THEME_REGISTRY: Record<string, ThemePlugin> = {
  'classic-quiz': classicQuiz,
  summer,
  'html-bridge': htmlBridge,
  'liquid-glass': liquidGlass,
  'pixel-art': pixelArt,
}

export function getTheme(themeId: string): ThemePlugin {
  const theme = THEME_REGISTRY[themeId]
  if (!theme) {
    console.warn(`Theme not found: ${themeId}, falling back to classic-quiz`)
    return classicQuiz
  }
  return theme
}

export function listThemes(): ThemePlugin[] {
  return Object.values(THEME_REGISTRY)
}

export function listThemesByCategory(): Map<ThemeCategory, ThemePlugin[]> {
  const map = new Map<ThemeCategory, ThemePlugin[]>()
  for (const theme of listThemes()) {
    const list = map.get(theme.category) ?? []
    list.push(theme)
    map.set(theme.category, list)
  }
  return map
}

export function getCategoryMeta(id: ThemeCategory) {
  return THEME_CATEGORIES.find(c => c.id === id)
}
